import styled from "styled-components";

export const Container = styled.div`
  overflow: hidden;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 24px;
  cursor: pointer;
`

export const Content = styled.div`
  padding: 24px;
  padding-top: 0;

  font-size: ${({ theme }) => theme.old.fonts.size.normal};
  font-weight: ${({ theme }) => theme.old.fonts.weight.regular};
`
